<template>
  <div class="outlook-editor-wrapper">
    <vue-editor
      v-model="internalValue"
      :editor-toolbar="customToolbar"
      placeholder="Comece a escrever seu e-mail..."
    />
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  name: 'EditorOutlook',
  components: { VueEditor },

  model: { prop: 'value', event: 'input' },

  props: {
    value: { type: String, default: '' },
  },

  data() {
    return {
      customToolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ color: [] }, { background: [] }],
      ],
    }
  },

  computed: {
    internalValue: {
      get() { return this.value || '' }, // ✅ protege null/undefined
      set(val) { this.$emit('input', val) },
    },
  },
}
</script>

<style lang="scss">
.outlook-editor-wrapper {
  .quillWrapper {
    transition: all 0.3s ease;
    border-radius: 4px !important;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(0, 0, 0, 0.38) !important;
    background-color: #fff !important;

    &:hover {
      border-color: rgba(0, 0, 0, 0.87) !important;
    }

    &:focus-within {
      border: 2px solid #1976d2 !important;
      margin: -1px;
    }

    .ql-toolbar.ql-snow {
      border: none !important;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
      background-color: #f5f5f5 !important;

      .ql-stroke { stroke: #444 !important; }
      .ql-fill   { fill: #444 !important; }
      .ql-picker  { color: #444 !important; }
    }

    .ql-container.ql-snow {
      border: none !important;

      .ql-editor {
        min-height: 200px;
        color: rgba(0, 0, 0, 0.87) !important;

        &.ql-blank::before {
          color: rgba(0, 0, 0, 0.38) !important;
        }
      }
    }
  }
}

.theme--dark {
  .outlook-editor-wrapper {
    .quillWrapper {
      border: 1px solid rgba(255, 255, 255, 0.24) !important;
      background-color: transparent !important;

      &:hover { border-color: rgba(255, 255, 255, 0.87) !important; }

      .ql-toolbar.ql-snow {
        background-color: rgba(255, 255, 255, 0.05) !important;
        border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;

        .ql-stroke { stroke: #e0e0e0 !important; }
        .ql-fill   { fill: #e0e0e0 !important; }
        .ql-picker  { color: #e0e0e0 !important; }
      }

      .ql-container.ql-snow .ql-editor {
        color: #fff !important;
        &.ql-blank::before { color: rgba(255, 255, 255, 0.5) !important; }
      }
    }
  }
}

.tag-helper {
  font-size: 11px;
  color: grey;
  padding-left: 4px;
  margin-top: 4px;
}
</style>
